import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("thom_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    // Anonymous session probes to /auth/me return 401 by design — swallow the
    // console noise on public pages so the console stays clean for real errors.
    const isAuthProbe = status === 401 && url.includes("/auth/me");
    if (isAuthProbe) {
      // Preserve the rejection for the AuthProvider to react to, but strip the
      // noisy `console.error` behaviour by returning a lightweight object.
      return Promise.reject({ ...error, __silent: true, message: "anonymous" });
    }
    if (status === 401 && !window.location.pathname.startsWith("/login")) {
      // don't hard-redirect from public pages
    }
    return Promise.reject(error);
  }
);

export default api;
